import { ExternalLink, X } from 'lucide-react';

import { Button } from '@/components/ui/button';
import { useAnnouncementBanner, useIsMobile } from '@/lib/hooks';

interface Props {
  href: string;
}

export function AnnouncementBanner({ href }: Props) {
  const [show, setShow] = useAnnouncementBanner();
  const mobile = useIsMobile();

  if (!show) return null;

  return (
    <div className="bg-primary flex h-12 items-center text-white">
      <img
        alt="Rocket icon"
        src="/rocket.svg"
        style={{
          height: '44px',
          marginTop: '4px',
          width: 'auto',
        }}
      />
      <div className="flex w-full items-center justify-between gap-4 pr-3">
        <div className="flex items-center gap-4">
          {!mobile && (
            <div className="font-bold">Exciting Updates Coming Soon!</div>
          )}
          <div className="flex items-center gap-2 text-sm underline">
            <a href={href} rel="noopener noreferrer" target="_blank">
              Learn more
            </a>
            <ExternalLink className="size-4" />
          </div>
        </div>
        <Button onClick={() => setShow(false)} size="icon">
          <X />
        </Button>
      </div>
    </div>
  );
}
